import { Grid } from "@mui/material";
import { useAppSelector } from '../../Redux/store';
import { AppSettings } from "../../Utils/Settings";
import { JobMarketplace } from './Components/JobMarketplace';
import { TalentMarketplace } from './Components/TalentMarketplace';

export const Marketplace = () => {
    /* ******************** Hooks ******************** */
    const userType = useAppSelector(state => state.Global.userType)
    // const {data: jobs, isLoading: isJobsLoading, isFetching: isJobsFetching} = useGetJobsQuery();
    // console.log(jobs)
    /* ******************** Variables ******************** */
    const isClient = userType === 'client';
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid 
            display={"grid"} 
            gridTemplateRows={'Repeat(3, auto)'}
            paddingLeft={'4%'}
            height={'100%'}
            paddingBottom={6}
            rowGap={4}
        >
            {isClient ? <TalentMarketplace /> : <JobMarketplace /> } 
        </Grid>
    )
}